import React from 'react';
import { connect } from 'react-redux';
import { getTerminals } from '../Dashboard/DashboardActions';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';

/**
 * Component to allow the selection of terminals.
 */
class TerminalSelector extends React.Component {

  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);


    this.state = {
      selectValue: this.props.terminalId,
    };

  }

  componentDidMount() {
    this.props.getTerminals();
  }


  updateValue(newValue) {
    this.props.onChange(newValue);

  }

  render() {

    let options = [];
    const { value } = this.props;


    this.props.terminals.forEach((value) => {
      options.push({ value: value._id, label: value.name });
    });

    return (

      <DropdownList
        data={options}
        textField='label'
        valueField='value'
        placeholder="Select terminal."
        value={value}
        onChange={this.updateValue}
      />

    );
  }
}

const mapStateToProps = (state) => ({
  terminals: state.business.terminals.get('data') || []
});

const mapDisptatchToProps = (dispatch) => ({
  getTerminals: () => dispatch(getTerminals()),
});

TerminalSelector.propTypes = {
  onChange: PropTypes.func,
  terminalId: PropTypes.string,
};

TerminalSelector.defaultProps = {
  onChange: () => true
};

export default connect(mapStateToProps, mapDisptatchToProps)(TerminalSelector);


// WEBPACK FOOTER //
// ./src/containers/TerminalSelector/TerminalSelector.js